import logo from "../images/logo.png";
import card1 from "../images/card1.png"
import myacc from "../images/myacc.png"
import loginicon from "../images/loginicon.png"
import googleicon from "../images/google-icon.png"
import innerbg from "../images/innerbg.png"

const images ={
    logo: logo ,
    card1 : card1,
    myacc: myacc,
    loginicon: loginicon,
    googleicon:googleicon,
    innerbg:innerbg,
}

export default images;